import { client } from '@/services/api/axios.ts';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { TPlant } from '@/features/plants/schemas/plants.schema.ts';

export const useGetPlantQuery = ({ plantId }: { plantId: string | undefined }) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ['plants', plantId],
    queryFn: async () => {
      const { data } = await client.get<{ body: TPlant }>(`/plants/${plantId}`);

      return data.body;
    },
    initialData: () => {
      const plantsWithoutOverview = queryClient.getQueryState<TPlant[]>(['plants']);
      const plantsWithOverview = queryClient.getQueryState<TPlant[]>(['plants', 'overview']);

      if (plantsWithOverview || plantsWithoutOverview) {
        const plants = plantsWithOverview || plantsWithoutOverview;

        if (plants && Date.now() - plants.dataUpdatedAt <= 5 * 60 * 1000) {
          const plant = plants?.data?.find((p) => p.plantId === plantId);

          return plant;
        }
      }
    },
  });
};
